/* eslint-disable */
import React, { useEffect, useContext, useReducer } from "react";
import * as qs from "query-string";
import callbackUrl from "pages/myutils/callbackUrl";
import { getToken, userLogout } from "../myutils/user";
import { setRequestToken, removeRequestToken } from "../myutils/request";
import { useRedirect } from "pages/hooks/redirect";
import { fangPhoneArr , fangZiArr} from "components/common";
import cookies from "js-cookie";
// todo 查找是否有本地user的cookie

const initialState = null
const UserContext = React.createContext(initialState);
const { axios, location } = window;

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return initialState
    case 'set-current-user':
      return {
        ...state,
        ...action.payload,
      }
    case 'set-current-company':
      return {
        ...state,
        company: action.payload,
      }
    case 'logout': {
      sessionStorage.clear();
      state.tmp || userLogout();
      removeRequestToken();
      axios.get("/customer/removeToken").then(data => {
        if (window.location.href.indexOf("mymymanager") !== -1) {
          window.location.pathname = "/mymymanager"
        } else {
          window.location.pathname = "/login"
        }
      });

      return {
        ...state,
        token: undefined,
        logout: true,
      }
    }
    default: {
      return state
    }
  }
}
export default function UserContextWrapped({ children, history }) {
  // const [self, setUser] = useState(null);
  const [self, dispatch] = useReducer(reducer, initialState)
  const [redirect, setTo] = useRedirect();
  const { domainId } = qs.parse(location.search);
  const value = { self, dispatch }

  function toLogin(params) {

    // const params = qs.parse(location.search)
    let search
    if (params.url || ['/', '/index', 'NavLayout ', '/register', '/mymymanager', '/authentication?'].includes(location.pathname)) {
      search = location.search
    } else {
      search = `url=${encodeURIComponent(location.href)}`
    }
    // const search = params.url ? qs.stringify(params) : `url=${encodeURIComponent(location.href)}`
    setTo({
      search,
      pathname: "/login"
    });
  }
  async function userProduce() {
    const [role, token] = getToken();
    const params = qs.parse(location.search);
    if(params.token){
      setRequestToken(token);
      cookies.set("shorcuts", token);
    }
    if (!token) {
      if (window.location.href.indexOf("/mymymanager") !== -1) {
        window.location.href = "/mymymanager"
      } else {
        toLogin(params);
      }
      return
    }
    // 临时用户
    if (role === '-1') {
      setTo({
        search: qs.stringify({
          ...params,
          token: undefined,
        }),
        pathname: location.pathname,
      })
    }
    // 修改逻辑，首先获取用户信息判定用户登陆状态是否有效

    if (window.location.href.indexOf("/mymymanager") !== -1 && cookies.get("adminShorcuts")) {
      setRequestToken(cookies.get("adminShorcuts"));
    } else {
      setRequestToken(cookies.get("shorcuts"));
    }
    const resInfo = await axios.get("/customer/userInfo")
    if (resInfo.status !== 200) {
      role !== '-1' && userLogout()
      setTimeout(() => {
        toLogin(params);
      }, 0)
      return
    }
    //  方舟不显示首页功能（个人身份）
    if (fangPhoneArr.includes(resInfo.data.phone)) { cookies.set("fangBol", true); }else{
      cookies.remove("fangBol");
    }
    if(resInfo.data.companySpecialAccount){
      const comId = resInfo.data.loginName.split("@")[1]
      if(fangZiArr.includes(comId)){
        cookies.set("fangBol", true);
      }
    }
    //  如果是新注册第一次登录 就显示弹窗 
    if (resInfo.data.newRegist) {
      cookies.set("regFirstBol", true);
    } else {
      cookies.remove("regFirstBol");
    }
    if (params.url) {
      callbackUrl(params, token);
      return
    }
    resInfo.data.token = token
    // qingyan 直接返回
    if (role === "0") {
      resInfo.data.qingyan = true
      dispatch({ type: 'set-current-user', payload: resInfo.data });
      return
    } else if (role === '-1') {
      resInfo.data.tmp = true
    }
    if (window.location.href.indexOf("/mymymanager") !== -1) {
      if (cookies.get("adminShorcuts")) {
        resInfo.data.qingyan = true
        setRequestToken(cookies.get("adminShorcuts"));
        dispatch({ type: 'set-current-user', payload: resInfo.data });
      } else {
        window.location.href = "/mymymanager"
      }
      return
    }
    const getCommanyNow = await axios.get(`/customer/current/company`)
    let companyid = ""
    if (getCommanyNow.data) {
      const { data } = getCommanyNow
      if (data.id) {
        companyid = data.id
      }
    }
    // let nowCommanyList ={}
    // if(getCommanyNow.data){
    //   const { data } =getCommanyNow
    //   nowCommanyList = {...data , companyId :data.id > 0 ? data.id : 0,
    //     companyName: data.name || null}
    // }
    const resStaff = await axios.get("/customer/staff")
    if (resStaff.status !== 200) {
      // toLogin(params);
      return;
    }
    const i = [];
    const j = [];
    resStaff.data && resStaff.data.forEach(p => {
      p.join ? j.push(p) : i.push(p);
      p.logo || (p.logo = "/img/no-logo.png");
    });
    resInfo.data.myCompanys = j
    resInfo.data.myInvitations = i
    console.log("params.companyid", params)
    if (companyid || params.companyid) {
      const id = Number.parseInt(companyid || params.companyid)
      const company = j.find(p => p.companyId === id)
      resInfo.data.company = company
      // if (company) {
      //   resInfo.data.company = company
      // }else{
      //   resInfo.data.company = nowCommanyList
      // }
    }
    dispatch({ type: 'set-current-user', payload: resInfo.data });
  }
  useEffect(() => {
    if (domainId) {
      self === null ? userProduce() :
        (self.logout && setTo({
          pathname: '/login?domainId=' + domainId
        }));
    } else {
      self === null ? userProduce() :
        (self.logout && setTo({
          pathname: '/login'
        }));
    }
  }, [self]);

  return (
    <UserContext.Provider value={value}>
      {children}
      {redirect}
    </UserContext.Provider>
  );
}

export function withUser(Component) {
  return function UserWrapped(props) {
    const user = useContext(UserContext);
    return <Component {...props} user={user} />;
  };
}
/* eslint-disable */
